"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var index_1 = require("../../../core/utils/index");

var RoundingRule_1 = require("../../model/rounding-rule/RoundingRule");

var RoundingRuleConverter_1 = require("./RoundingRuleConverter");
/**
 * Default implementation of {@link RoundingRuleConverter}.
 *
 * @author RV
 */


var RoundingRuleConverterImpl =
/*#__PURE__*/
function (_RoundingRuleConverte) {
  _inherits(RoundingRuleConverterImpl, _RoundingRuleConverte);

  function RoundingRuleConverterImpl() {
    _classCallCheck(this, RoundingRuleConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(RoundingRuleConverterImpl).apply(this, arguments));
  }

  _createClass(RoundingRuleConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new RoundingRule_1.RoundingRule(conversions.documentToClassId(source), conversions.toBigNumber(source.roundingStep), conversions.toBigNumber(source.startingAt), index_1.Utils.isValueMissing(source.threshold1) ? null : conversions.toBigNumber(source.threshold1), index_1.Utils.isValueMissing(source.threshold10) ? null : conversions.toBigNumber(source.threshold10), source.useBataPrice1, source.useBataPrice10, index_1.Utils.isValueMissing(source.decrease1) ? null : conversions.toBigNumber(source.decrease1), index_1.Utils.isValueMissing(source.decrease10) ? null : conversions.toBigNumber(source.decrease10), source.weighted);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        roundingStep: conversions.fromBigNumber(source.roundingStep),
        startingAt: conversions.fromBigNumber(source.startingAt),
        threshold1: source.threshold1 && conversions.fromBigNumber(source.threshold1),
        threshold10: source.threshold10 && conversions.fromBigNumber(source.threshold10),
        useBataPrice1: source.useBataPrice1,
        useBataPrice10: source.useBataPrice10,
        decrease1: source.decrease1 && conversions.fromBigNumber(source.decrease1),
        decrease10: source.decrease10 && conversions.fromBigNumber(source.decrease10),
        weighted: source.weighted
      });
      return result;
    }
  }]);

  return RoundingRuleConverterImpl;
}(RoundingRuleConverter_1.RoundingRuleConverter);

exports.RoundingRuleConverterImpl = RoundingRuleConverterImpl;